import "dayjs/locale/ru";

import { getSiteDeploymentStatus } from "@app/shared/lib/Functions";
import { LoadingIndicator } from "@app/shared/ui/LoadingIndicator";
import { useCurrentGameProfileQueryIfGameAvailable } from "@entities/user/api/useCurrentGameProfileQueryIfGameAvailable.ts";
import { FxIdWebFeaturesProfileGetResponse } from "@fxid/openapi-client";
import { Center, Container, Stack } from "@mantine/core";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import { useUserProfileSettingsButtonState } from "../../../packages/fxid-shared/src/models/AppStore.ts";
import { ConnectedGamesSection } from "./ConnectedGamesSection";
import { RestrictedProfile } from "./RestrictedProfile";
import { UserProfileCard } from "./UserProfileCard";

/**
 * Основной компонент страницы профиля пользователя.
 * Отвечает за получение данных, обработку состояний загрузки и отображение
 * ограниченного вида профиля в зависимости от контекста.
 */
export const Profile = () => {
	const { data } = useCurrentGameProfileQueryIfGameAvailable();
	const params = useParams();
	const { social, isIframe } = getSiteDeploymentStatus(params);

	const isProfileRestricted = (social !== null && social !== "FxId") || isIframe;

	const [, { disable: disableUserProfileSettingsButton, reset: resetUserProfileSettingsButton }] =
		useUserProfileSettingsButtonState();

	useEffect(() => {
		if (!isProfileRestricted) return;
		disableUserProfileSettingsButton();

		return () => resetUserProfileSettingsButton();
	}, [disableUserProfileSettingsButton, resetUserProfileSettingsButton, isProfileRestricted]);

	if (!data) {
		return (
			<Center>
				<LoadingIndicator />
			</Center>
		);
	}

	if (isProfileRestricted) {
		return <RestrictedProfile />;
	}

	return (
			<UserProfileCard profile={data as FxIdWebFeaturesProfileGetResponse} />
	);
};
